import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  Chip,
  List,
  ListItem,
  ListItemText,
  Stack,
  Switch,
  Typography
} from '@mui/material';
import { AutoAwesome as AssistantIcon } from '@mui/icons-material';
import { collection, doc, onSnapshot } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../../firebase/config';

/**
 * Kurzüberblick zum Venue-Bestellkanal in den Einstellungen; die eigentliche
 * Einrichtung läuft über den Assistenten.
 * Konzept: docs/general/venue_bestellknopf_taxibutler_konzept.md (§10.7)
 */
const VenueChannelSettingsSection = ({ canManage }) => {
  const [enabled, setEnabled] = useState(false);
  const [venueCount, setVenueCount] = useState(0);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      doc(db, 'appSettings', 'venueChannel'),
      (snapshot) => setEnabled(snapshot.exists() && snapshot.data().enabled === true),
      () => undefined
    );
    return unsubscribe;
  }, []);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, 'venues'),
      (snapshot) => setVenueCount(snapshot.size),
      () => undefined
    );
    return unsubscribe;
  }, []);

  const handleToggle = async (nextEnabled) => {
    setSaving(true);
    try {
      const callable = httpsCallable(functions, 'configureVenueChannel');
      await callable({ enabled: nextEnabled });
    } catch {
      // Der Schalter folgt dem Firestore-Listener; bei Fehlern bleibt der alte Stand.
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box>
      <Box sx={{ p: 2, bgcolor: 'grey.100' }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="subtitle1" fontWeight="bold" sx={{ flexGrow: 1 }}>
            Bestellknopf (Venue)
          </Typography>
          {enabled && <Chip size="small" color="success" label="Aktiv" />}
        </Stack>
        <Typography variant="caption" color="text.secondary">
          Bestellgeräte in Hotels, Restaurants und Kliniken — Personal drückt einen
          Knopf, die Fahrt landet direkt in der Disposition
        </Typography>
      </Box>

      <List disablePadding>
        <ListItem
          secondaryAction={
            <Switch
              edge="end"
              checked={enabled}
              onChange={(event) => handleToggle(event.target.checked)}
              disabled={!canManage || saving}
              color="primary"
            />
          }
        >
          <ListItemText
            primary="Venue-Bestellungen annehmen"
            secondary={
              venueCount > 0
                ? `${venueCount} Bestellort${venueCount === 1 ? '' : 'e'} eingerichtet`
                : 'Noch kein Bestellort eingerichtet'
            }
          />
        </ListItem>
      </List>

      <Box sx={{ px: 2, pb: 2 }}>
        <Button
          component={RouterLink}
          to="/einstellungen/bestellknopf-einrichtung"
          variant="outlined"
          startIcon={<AssistantIcon />}
          disabled={!canManage}
        >
          Assistent
        </Button>
      </Box>
    </Box>
  );
};

export default VenueChannelSettingsSection;
